import { PageController } from '@client/components/_core/layout/PageController';
import { OrgContactRoleEdit } from '@client/components/products-v2/OrgContactRoleEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/contact-roles/edit/$contactRoleId')(
    {
        staticData: {
            presentation: 'overlay',
            metadata: {
                title: 'Edit contact role',
            },
        },
        params: {
            parse({ contactRoleId }) {
                return {
                    contactRoleId: BigInt(contactRoleId),
                };
            },
        },
        component: RouteComponent,
    },
);

function RouteComponent() {
    return (
        <PageController route={Route}>
            <OrgContactRoleEdit action={['edit', Route.useParams().contactRoleId]} />
        </PageController>
    );
}
